var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { USDCLogo, WBTCLogo, WETHLogo, YVUSDcLogo, } from "../assets/icons/erc20Assets";
import colors from "../designSystem/colors";
export var getAssetDisplay = function (asset) {
    switch (asset) {
        case "WETH":
            return "ETH";
        default:
            return asset;
    }
};
export var getAssetDecimals = function (asset) {
    switch (asset) {
        case "WBTC":
            return 8;
        case "USDC":
        case "yvUSDC":
            return 6;
        default:
            return 18;
    }
};
export var getDefaultSignificantDecimalsFromAssetDecimals = function (decimals) {
    switch (decimals) {
        case 18:
            return 6;
        case 8:
            return 5;
        case 6:
        default:
            return 2;
    }
};
export var getAssetDefaultSignificantDecimals = function (asset) {
    return getDefaultSignificantDecimalsFromAssetDecimals(getAssetDecimals(asset));
};
export var getAssetColor = function (asset) { return colors.asset[asset]; };
var ColoredWBTCLogo = styled(WBTCLogo)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  && * {\n    fill: ", ";\n  }\n"], ["\n  width: 100%;\n  && * {\n    fill: ", ";\n  }\n"])), colors.asset.WBTC);
var ColoredUSDCLogo = styled(USDCLogo)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: -8px;\n  width: 100%;\n\n  && .background {\n    fill: ", ";\n  }\n\n  && .content {\n    fill: ", ";\n  }\n"], ["\n  margin: -8px;\n  width: 100%;\n\n  && .background {\n    fill: ", ";\n  }\n\n  && .content {\n    fill: ", ";\n  }\n"])), function (props) {
    return props.backgroundColor ? props.backgroundColor : colors.asset.USDC + "29";
}, colors.asset.USDC);
var ColoredYVUSDCLogo = styled(YVUSDcLogo)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: -8px;\n  width: 100%;\n\n  && .background {\n    fill: ", ";\n  }\n\n  && .content {\n    fill: ", ";\n  }\n"], ["\n  margin: -8px;\n  width: 100%;\n\n  && .background {\n    fill: ", ";\n  }\n\n  && .content {\n    fill: ", ";\n  }\n"])), function (props) {
    return props.backgroundColor ? props.backgroundColor : colors.asset.USDC + "29";
}, colors.asset.USDC);
export var getAssetLogo = function (asset) {
    switch (asset) {
        case "USDC":
            return ColoredUSDCLogo;
        case "WBTC":
            return ColoredWBTCLogo;
        case "WETH":
            return WETHLogo;
        case "yvUSDC":
            return ColoredYVUSDCLogo;
    }
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=asset.js.map